import { z } from 'zod';
import { transformAST, xml2ast, allHtmlParsers, isASTTextNode } from '@utils/ast';
import { expandSelfClosingTags } from '@utils/common';
import { baseTaskSchema } from '../schema.base.js';
import { dropdownInput } from './input.dropdown.js';
import { wordDropdownInput } from './input.word-dropdown.js';

const selectAnswersDropdownTaskSchema = baseTaskSchema.extend({
  taskType: z.literal("SelectAnswers"),
  answerType: z.literal("DropDown"),
  text: z.string()
}).transform(({
  text,
  ...rest
}) => ({
  ...rest,
  content: transformAST(xml2ast(expandSelfClosingTags(text), {
    ...allHtmlParsers,
    ...dropdownInput.parsers,
    ...wordDropdownInput.parsers
  }, "text/html", {
    context: {
      taskId: rest.id
    }
  }), (node, context) => {
    //
    // STEP: add spaces after inputs, in case two inputs immediately follow
    // each other. This is currently necessary in the frontend layer, as it
    // is impossible to see if spaces has been forgotten in the backend
    // Editor during task creation. As of 29-11-24.
    //
    // See ADO #126415
    //
    if (node?.nodeType === "dropdown-input" || node?.nodeType === "word-dropdown-input") {
      const nextNode = context.siblingNodes[context.index + 1];
      if (nextNode?.nodeType === "dropdown-input" || nextNode?.nodeType === "word-dropdown-input") {
        // NB: We prefer the final whitespace outside the word-dropdown if
        // possible, as this will ensure a nicer layout.
        if (node.nodeType === "word-dropdown-input" && node.label?.endsWith(" ")) {
          node.label = node.label.replace(/ $/, "");
        }
        return [node, {
          nodeType: "text",
          value: " "
        }];
      }

      //
      // STEP: Furthermore we would like our dropdowns to be followed by a
      // space or punctuation
      //
      if (node.nodeType === "word-dropdown-input" && isASTTextNode(nextNode) && !/^[\s.,?!]/.test(nextNode.value) && !/[\s.,?!]$/.test(node.label ?? "")) {
        return [node, {
          nodeType: "text",
          value: " "
        }];
      }
      if (node.nodeType === "dropdown-input" && isASTTextNode(nextNode) && !/^[\s.,?!]/.test(nextNode.value)) {
        return [node, {
          nodeType: "text",
          value: " "
        }];
      }
    }
    return node;
  })
}));

export { selectAnswersDropdownTaskSchema };
//# sourceMappingURL=_schema.js.map
